module.exports = __webpack_public_path__ + "static/media/optima-seguros-minus.b8dd4aff.svg";